import React from 'react';
import { Link } from 'react-router-dom';
import { LegalLayout } from './LegalLayout';

export const Refunds: React.FC = () => {
  return (
    <LegalLayout
      kicker="Legal"
      title="Refund Policy"
      lastUpdated="October 2, 2026"
      documentTitle="Refund Policy — PaperBrain"
      intro="Plain-English version: if you're not happy, ask within 14 days of a payment and you'll get a full refund. Below is the longer version."
    >
      <h2>1. Who handles your purchase</h2>
      <p>
        PaperBrain is operated by Byte-Sized Bits, LLC. Subscriptions bought on
        paperbrain.dev are sold by our online reseller, <strong>Paddle.com</strong>,
        which is the Merchant of Record for those orders. Paddle processes the
        payment, issues your receipt and invoice, and handles refunds and
        order-related questions.
      </p>
      <p>
        Subscriptions bought inside the PaperBrain iPhone or Android app are
        sold by Apple or Google instead, and their refund policies apply — see
        section 5.
      </p>

      <h2>2. Free trial</h2>
      <p>
        New accounts start with a free trial. You can cancel at any time during
        the trial from your account, and you won't be charged. If you don't
        cancel, your subscription starts and your first payment is taken when
        the trial ends.
      </p>

      <h2>3. Cancelling</h2>
      <p>
        You can cancel anytime from <strong>Account → Manage subscription</strong>.
        Cancelling stops future renewals; you keep access until the end of the
        period you've already paid for. You won't be charged again.
      </p>

      <h2>4. Refunds</h2>
      <p>
        We offer a <strong>14-day refund policy</strong>. You can request a
        full refund within 14 days of any payment for a subscription bought on
        paperbrain.dev.
      </p>
      <p>
        When a refund is issued for your current subscription, the subscription
        is cancelled at the same time and your access ends.
      </p>

      <h2>5. Purchases made in the mobile apps</h2>
      <p>
        If you subscribed through the App Store or Google Play, refunds are
        handled by Apple or Google under their policies — we can't issue them
        ourselves. Request one through Apple's{' '}
        <a href="https://reportaproblem.apple.com" target="_blank" rel="noreferrer">
          Report a Problem
        </a>{' '}
        page or{' '}
        <a href="https://support.google.com/googleplay/answer/2479637" target="_blank" rel="noreferrer">
          Google Play
        </a>
        .
      </p>

      <h2>6. How to ask for a refund</h2>
      <p>
        For purchases made on paperbrain.dev, email us at{' '}
        <a href="mailto:hello@bytesizedbits.com">hello@bytesizedbits.com</a> with the
        email address on your account, or contact Paddle directly through{' '}
        <a href="https://paddle.net" target="_blank" rel="noreferrer">
          paddle.net
        </a>{' '}
        using the details on your receipt.
      </p>

      <h2>7. Related</h2>
      <p>
        See our <Link to="/terms">Terms of Service</Link> for the full
        subscription terms and our <Link to="/privacy">Privacy Policy</Link> for
        what payment data we and Paddle hold.
      </p>

      <h2>8. Contact</h2>
      <div className="legal-contact">
        Questions about a charge? Email{' '}
        <a href="mailto:hello@bytesizedbits.com">hello@bytesizedbits.com</a>.
      </div>
    </LegalLayout>
  );
};
